<div class="trialperiod-team">
	<section class="section-datatable">
		<ng-container *ngIf="loadingStates.datatable; else datatableBlock">
			<ng-container *ngTemplateOutlet="loadingComponent"></ng-container>
		</ng-container>
		<ng-template #datatableBlock>
			<div class="card card-fit card-table shadow">
				<div class="card-header border-bottom">
					<ng-container *ngTemplateOutlet="cardHeader"></ng-container>
				</div>
				<div class="card-body card-table p-0">
					<div class="table-responsive">
						<ngx-datatable class="ngx-datatable-custom" [rows]="list" [count]="count"
							[limit]="queryParams.top" [offset]="queryParams.skip / queryParams.top" [rowHeight]="'auto'"
							[columnMode]="'force'" [headerHeight]="56" [footerHeight]="56" [externalPaging]="true"
							[externalSorting]="true" [sorts]="currentSort ? [currentSort] : []"
							[loadingIndicator]="loadingStates.datatable" (page)="onPage($event)"
							(sort)="onSort($event)">
							<ngx-datatable-column name="Ação" prop="title">
								<ng-template ngx-datatable-header-template let-column="column">
									Ação
								</ng-template>
								<ng-template ngx-datatable-cell-template let-row="row">
									<span>{{ row.title }}</span>
								</ng-template>
							</ngx-datatable-column>

							<ngx-datatable-column [sortable]="false" [maxWidth]="120">
								<ng-template ngx-datatable-cell-template let-row="row" let-rowIndex="rowIndex">
									<button class="btn btn-icon btn-sm" type="button"
										(click)="handleCreateOrUpdate(row)" ngbTooltip="Editar Ação">
										<i data-feather="edit" size="15"></i>
									</button>
								</ng-template>
							</ngx-datatable-column>
						</ngx-datatable>
					</div>
					<div class="card-footer">
						<app-paginator type="squared" class="flex-1" [count]="count" [filter]="queryParams.filter"
							[queryParams]="queryParams" (query)="executeQuery()"></app-paginator>
					</div>
				</div>
			</div>
		</ng-template>
	</section>
</div>

<ng-template #loadingComponent>
	<div class="card card-fit card-table shadow">
		<div class="card-header border-bottom">
			<ng-container *ngTemplateOutlet="cardHeader"></ng-container>
		</div>
		<div class="card-body pt-2">
			<div class="flex flex-1 gap-2 p-1 flex-column justify-content-center align-items-center">
				<span class="spinner-border text-primary spinner-border-lg mr-1"></span>
				<span>Carregando</span>
			</div>
		</div>
	</div>
</ng-template>

<ng-template #cardHeader>
	<div>
		<h4 class="mb-0">Ações plano de ação</h4>
		<span class="description" *ngIf="description">{{ description }}</span>
	</div>

	<button class="btn btn-light-primary btn-primary-action text-primary" type="button"
		(click)="handleCreateOrUpdate()">
		<i data-feather="plus"></i> Nova ação
	</button>
</ng-template>